<template>
  <div>
    <section id="content">
      <Breadcrumb :breadcrumbs="breadcrumbs" />
      <section class="content-row">
        <div class="container">
          <div class="column-row">
            <div class="column-80">
              <article class="blog-article">
                <header class="blog-news-header">
                  <h3 v-if="$i18n.locale === 'mn'">{{ singleNews.title }}</h3>
                  <h3 v-if="$i18n.locale === 'en'">
                    <span v-if="singleNews.title_en">{{
                      singleNews.title_en
                    }}</span>
                    <span v-else>{{ singleNews.title }}</span>
                  </h3>

                  <ul class="post-bread">
                    <li>
                      {{ singleNews.published_date | moment("YYYY-MM-DD") }}
                    </li>
                    <li class="active" v-if="singleNews.categories">
                      <router-link
                        :to="`/mn/categorypage/${category.id}`"
                        v-for="category in singleNews.categories"
                        :key="category.id"
                        ><span v-if="$i18n.locale === 'mn'">{{
                          category.title
                        }}</span>
                        <span v-if="$i18n.locale === 'en'">{{
                          category.title_en
                        }}</span>
                        </router-link>
                    </li>
                  </ul>
                </header>
                <div class="blog-article-content">
                  <vue-markdown
                    v-if="$i18n.locale === 'mn'"
                    :source="singleNews.body"
                    :html="html"
                    :image="image"
                  ></vue-markdown>
                  <vue-markdown
                    v-if="$i18n.locale === 'en'"
                    :source="singleNews.body_en || singleNews.body"
                    :html="html"
                    :image="image"
                  ></vue-markdown>
                </div>
              </article>
            </div>
            <div class="column-20 news-type">
              <h4>{{ $t("newsType") }}</h4>
              <Categories />
            </div>
            <div class="column-20"></div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import Categories from "@/components/parts/Categories.vue";
import VueMarkdown from "vue-markdown";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";

export default {
  name: "SingleNews",
  components: {
    Categories,
    VueMarkdown,
    Breadcrumb
  },
  data: function() {
    return {
      singleNews: {},
      html: true,
      image: false
    };
  },
  computed: {
    breadcrumbs() {
      if (this.$i18n.locale === "mn") {
        return [
          {
            title: this.singleNews.title,
            links: [
              { name: this.$t("nav.homePage"), path: "/mn/#/" },
              { name: this.$t("nav.news"), path: "/#/mn/news" },
              { name: this.singleNews.title, path: "/#/mn/news/" + this.singleNews.id }
            ]
          }
        ];
      } else {
        return [
          {
            title: this.singleNews.title_en,
            links: [
              { name: this.$t("nav.homePage"), path: "/" },
              { name: this.$t("nav.news"), path: "/#/news" },
              { name: this.singleNews.title_en, path: "/" }
            ]
          }
        ];
      }
    }
  },
  async mounted() {
    await this.axios
      .get(`https://api.mncert.org/posts/${this.$route.params.newsId}`)
      .then(response => (this.singleNews = response.data));
  }
};
</script>
<style lang="scss" scoped>
.blog-article .blog-article-content {
  margin-top: 40px !important;
}
</style>
